import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  get,
} from 'lodash';
import {
  transparent,
} from 'vibeguide';
import Playlist from '../../../../../Programs/Baselines/Calendar/Items/Playlist';
import Mix from '../../../../../Programs/Baselines/Calendar/Items/Mix';
import './MusicItem.scss';

function MusicItem({
  style = {},
  type,
  playlist = {},
  station = {},
  minStartTime = '',
  maxStopTime = '',
  color,
  fullView = false,
  readOnly = false,
}) {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
  };

  const onMouseLeave = () => {
    setHover(false);
  };

  const archived = type === 'playlist'
    ? !get(playlist, 'playlist.active')
    : !get(station, 'mix.active');

  const color10 = transparent(color, 10);
  const color20 = transparent(color, 20);
  const color25 = transparent(color, 25);
  const color35 = transparent(color, 35);
  const color84 = transparent(color, 84);

  const itemStyle = {
    background:
      hover
        ? archived
          ? `repeating-linear-gradient(45deg, ${color25}, ${color25} 10px, ${color35} 10px, ${color35} 20px)`
          : color35
        : archived
          ? `repeating-linear-gradient(45deg, ${color10}, ${color10} 10px, ${color20} 10px, ${color20} 20px)`
          : color25,
    border: `1px solid ${color84}`,
    boxSizing: 'border-box',
    ...style,
  };

  return (
    <div
      className="MusicItem"
      style={itemStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {fullView && (
        <div
          style={{
            height: '100%',
          }}
        >
          {type === 'playlist' ? (
            <Playlist
              id={playlist._uniqueId}
              playlist={playlist.playlist}
              startTime={playlist.startTime}
              stopTime={playlist.stopTime}
              minStartTime={minStartTime}
              maxStopTime={maxStopTime}
              archived={archived}
              readOnly={readOnly}
            />
          ) : (
            <Mix
              id={playlist._uniqueId}
              mix={station.mix}
              startTime={station.startTime}
              stopTime={station.stopTime}
              minStartTime={minStartTime}
              maxStopTime={maxStopTime}
              archived={archived}
              readOnly={readOnly}
            />
          )}
        </div>
      )}
    </div>
  );
}

MusicItem.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  type: PropTypes.oneOf([
    'playlist',
    'station',
  ]).isRequired,
  playlist: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  station: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Prevent starting before */
  minStartTime: PropTypes.string,
  /** Prevent stopping after */
  maxStopTime: PropTypes.string,
  color: PropTypes.string.isRequired,
  /** View entire item */
  fullView: PropTypes.bool,
  /** All data in the schedule is read-only */
  readOnly: PropTypes.bool,
};

export default MusicItem;
